import React from "react";
import {
  Card,
  CardBody,
  CardTitle,
  Button,
  Spinner,
  Form,
  FormGroup,
} from "reactstrap";
import PropTypes from "prop-types";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../contexts/AuthContext";

export const ForgotPasswordResult = ({ userData }) => {
  const { login } = useAuth();
  const navigate = useNavigate();

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {},
    validationSchema: Yup.object({}),
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true);
      if (!userData?.email || !userData?.password) {
        navigate("/");
        return;
      }

      try {
        // Attempt to log in with the new credentials
        await login({
          email: userData.email,
          password: userData.password,
        });

        // Redirect to dashboard on successful login
        navigate("/");
      } catch (error) {
        console.error("Auto-login failed:", error);
        navigate("/");
      } finally {
        setSubmitting(false);
        setIsLoggingIn(false);
      }
    },
  });

  return (
    <Card className="card-auth">
      <CardTitle className="text-center">
        <h1 className="text-4xl fw-semibold">ตั้งรหัสผ่านใหม่สำเร็จ</h1>
      </CardTitle>
      <CardBody className="text-center">
        <Form
          className="w-full"
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}
        >
          <h4 className="text-gray-500 mb-4">
            กรุณาคลิกที่ปุ่มด้านล่างเพื่อไปหน้าเข้าสู่ระบบ <br />
            ใช้รหัสผ่านใหม่เพื่อเข้าสู่ระบบได้ทันที
          </h4>

          <FormGroup className="space-y-4">
            <div className="w-full">
              <Button
                type="submit"
                color="primary"
                size="lg"
                className="py-2 w-full"
                disabled={!validation.isValid || validation.isSubmitting}
              >
                {validation.isSubmitting ? (
                  <>
                    <Spinner size="sm" />
                    กำลังเข้าสู่ระบบ...
                  </>
                ) : (
                  "เข้าสู่หน้าหลัก"
                )}
              </Button>
            </div>
          </FormGroup>
        </Form>
      </CardBody>
    </Card>
  );
};

ForgotPasswordResult.propTypes = {
  userData: PropTypes.shape({
    email: PropTypes.string.isRequired,
    password: PropTypes.string.isRequired,
  }),
};

export default ForgotPasswordResult;
